export const handlelocalstorageSet = () => {
	let win = document.getElementById("helperFrame").contentWindow
	const session = localStorage.getItem("amplify-signin-with-hostedUI")
	if (!!session) {
		const usertoken = { ...localStorage }
		const keyname = Object.getOwnPropertyNames(usertoken)
		keyname.map((item) =>
			win.postMessage(
				JSON.stringify({ method: "set", key: item, data: usertoken[item] }),
				"https://blogs.mixedmodel.academy"
			)
		)
	}
}

export const handlelocalstorageSetcookie = () => {
	localStorage.setItem("UsedCookie", "true")
	let win = document.getElementById("helperFrame").contentWindow
	win.postMessage(
		JSON.stringify({ method: "set", key: "UsedCookie", data: "true" }),
		"https://blogs.mixedmodel.academy"
	)
}

export const handlelocalstorageClear = () => {
	let win = document.getElementById("helperFrame").contentWindow
	win.postMessage(
		JSON.stringify({ method: "clear" }),
		"https://blogs.mixedmodel.academy"
	)
}
